document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".stockist-section");



  
  sections.forEach(section => {
    const sectionId = section.id.replace("stockist-section-", "");
    const countrySelect = document.getElementById(`stockist-country-${sectionId}`);
    const stockistList = section.querySelector(".stockist-list");
    const loadMoreBtn = section.querySelector(".stockist-loadmore-button");

    if (!countrySelect || !stockistList) return;

    const items = Array.from(stockistList.querySelectorAll(".stockist-item"));
    const batchSize = parseInt(stockistList.dataset.batchSize || 0);
    let shownItems = batchSize;

    // Build country filter
    const countries = [...new Set(items.map(i => i.dataset.country).filter(c => c))].sort();
    countries.forEach(c => {
      const opt = document.createElement("option");
      opt.value = c;
      opt.textContent = c.toUpperCase();
      countrySelect.appendChild(opt);
    });

    function getFilteredItems() {
      const selected = countrySelect.value;
      return selected === "all" ? items : items.filter(item => item.dataset.country === selected);
    }

    function renderItems() {
      const filteredItems = getFilteredItems();

      filteredItems.forEach((item, index) => {
        item.style.display = index < shownItems ? "block" : "none";
      });

      items.forEach(item => {
        if (!filteredItems.includes(item)) item.style.display = "none";
      });

      if (loadMoreBtn) {
        loadMoreBtn.style.display = shownItems < filteredItems.length ? "inline-block" : "none";
      }
    }

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener("click", () => {
        const filteredItems = getFilteredItems();
        shownItems = Math.min(shownItems + batchSize, filteredItems.length);
        renderItems();
      });
    }

    countrySelect.addEventListener("change", () => {
      shownItems = batchSize;
      renderItems();
    });

    window.addEventListener("scroll", () => {
      
      const filteredItems = getFilteredItems();
      if (!loadMoreBtn || loadMoreBtn.style.display === "none") return;

      const rect = stockistList.getBoundingClientRect();
      if (rect.bottom - window.innerHeight < 10) {
        shownItems = Math.min(shownItems + batchSize, filteredItems.length);
        renderItems();
      }
    });

    renderItems();
  });
});
